import React from "react";

const Tutorials = () => {
  return <div>Tutorials Page</div>;
};

export default Tutorials;
